// extracted by mini-css-extract-plugin
export default {"container":"ImageCard_container__MctgX","imgContainer":"ImageCard_imgContainer__pQuYU","iconContainer":"ImageCard_iconContainer__IVVGK","nameText":"ImageCard_nameText__6oVnB"};